import { CMSTransformerDataType } from 'types/common';
import type { TabData } from '@nextgen-web-framework/all';

type TranslationFunction = (str: string, values?: Record<string, string>) => string;
interface GetContentDataProps {
  t: TranslationFunction;
  data?: CMSTransformerDataType;
  all?: boolean;
  initialSectionId?: string;
}
const getContentData = ({ t, data, initialSectionId, all }: GetContentDataProps) => {
  const FILTER_ALL_ID = 'all';
  const pillTabData = [
    all
      ? {
          id: FILTER_ALL_ID,
          title: t(`amshop.contentPage.filter.all`),
        }
      : undefined,
    ...(data?.categories?.map((category: CMSTransformerDataType) => ({
      id: category.slug,
      title: category.name,
    })) ?? []),
  ].filter(Boolean);
  const pillIndex = pillTabData?.findIndex((category: TabData) => category.id === initialSectionId);
  let initialSelectedId = 0;
  if (~pillIndex) {
    initialSelectedId = pillIndex;
  }
  return { pillTabData, initialSelectedId };
};

export default getContentData;
